<template>
    <div class="d-inline-block">
        <!-- Geolocation dropdown -->
        <div :id="'dropdown-'+details.id"
             class="dropdown keep-inside-clicks-open dropdown-note-editor d-inline-block">
            <button type="button"
                    class="btn p-0 mb-1 primary-text-color"
                    data-toggle="dropdown">
                <app-icon name="map-pin" class="size-18"/>
            </button>
            <div class="dropdown-menu p-primary mt-1">
                <div>
                    <p class="text-secondary">
                        {{ $t('geo_location_data') }}
                    </p>
                    <div class="note note-warning custom-scrollbar p-4 mb-5">
                        <p class="m-0" v-if="value.ip"><label class="font-weight-bold">IP:</label> {{ value.ip }}</p>
                        <p class="m-0" v-if="value.location"><label class="font-weight-bold">Location:</label> {{ value.location }}</p>
                        <p class="m-0" v-if="value.city"><label class="font-weight-bold">City:</label> {{ value.city }}</p>
                        <p class="m-0" v-if="value.state_prov"><label class="font-weight-bold">State:</label> {{ value.state_prov }}</p>
                        <p class="m-0" v-if="value.country_name"><label class="font-weight-bold mb-0">Country:</label> {{ value.country_name }}</p>
                    </div>

                    <div class="text-right">

                        <a href="#"
                           class="btn btn-secondary"
                           @click.prevent="closeDropDown">
                            {{ $t('close') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Image icon (only shown if images exist) -->
        <button v-if="hasImages"
                type="button"
                class="btn p-0 mb-1 ml-2 primary-text-color"
                @click="showImageModal = true">
            <app-icon name="image" class="size-18"/>
        </button>

        <!-- Image Modal -->
        <app-modal v-if="showImageModal"
                   modal-id="attendance-images-modal"
                   modal-size="large"
                   modal-alignment="top"
                   @close-modal="closeModal">
            <template slot="header">
                <h5 class="modal-title">{{ $t('images') }}</h5>
                <button type="button" class="close" @click="closeModal">
                    <span>&times;</span>
                </button>
            </template>
            <template slot="body">
                <div class="row">
                    <div v-for="(image, index) in value.images" :key="index" class="col-lg-3 col-md-4 mb-3">
                        <img :src="image" class="img-fluid rounded" style="width: 100%; aspect-ratio: 1/1; object-fit: cover; cursor: pointer;" @click="openFullImage(image)"/>
                    </div>
                </div>
            </template>
        </app-modal>
    </div>
</template>

<script>

export default {
    name: "PunchGeolocationData",
    props: {
        details: {},
        keyData: {
            default: () => 'in_ip_data'
        }
    },

    data() {
        return {
            showImageModal: false
        }
    },

    computed: {
        value() {
            return this.details[this.keyData] ? JSON.parse(this.details[this.keyData]) : {};
        },
        hasImages() {
            return this.value.images && this.value.images.length > 0;
        }
    },

    methods: {
        closeDropDown() {
            $(".dropdown-menu").removeClass('show')
        },
        openFullImage(imageUrl) {
            window.open(imageUrl, '_blank');
        },
        closeModal() {
            this.showImageModal = false;
            // Remove backdrop
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        }
    }

}
</script>

<style scoped lang="scss">
.dropdown {
    .dropdown-menu {
        width: 350px;

        .note {
            overflow-y: auto;
            max-height: 200px;
        }
    }
}
</style>